/* @ngInject */
function expirationFilter ($filter, $translate) {
  return function (date) {
    if (!date) {
      return $translate.instant('noDate')
    }
    const newDate = moment(date)
    const today = moment()
    const nextWeek = moment().add(7, 'days')

    if (newDate < today) {
      return newDate.format('DD MMM')
    }

    if (newDate <= nextWeek) {
      return newDate.fromNow(true)
    }

    return newDate.format('DD MMM')
  }
}

export { expirationFilter }
